import TEXT, { HTMLELEMENT } from '../../DOM/text/TEXT.js';
import { makeAttrStruct } from '../../../enums/ModelAttr.js';
import { makeDataStruct } from '../../../enums/ModelData.js';
import { makeStruct } from '../../../enums/MODELS.js';
// Model Structure
export const codeElementAttr = makeAttrStruct([]);
export const codeElementData = makeDataStruct([
    ['language'],
    ['code']
]);
export const codeElementModel = makeStruct([
    ['attributes', codeElementAttr],
    ['data', codeElementData]
]);
// Simplified Model
export function code(language, code) {
    return codeElementModel(codeElementAttr(), codeElementData(language, code));
}
export default class CODE extends TEXT {
    constructor(node, model) {
        super(node, HTMLELEMENT.CODE, model);
        this.addClass('language-' + model.data.language);
    }
}
